import RunningGameList from './RunnningGameList.vue';
import RunningGame from './RunningGame.vue';

export default {
  RunningGameList,
  RunningGame,
};
